import React from 'react'
import { CircleBox as OriginalCircleBox } from '@next-nx/shared-ui/molecules'
import { CircleBoxSettings } from './CircleBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  animationVariant: 'vertical',
  ctaLabel: '',
  link: '',
  pageLink: '',
  openNewTab: false,
}

export const CircleBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { 
      animationVariant,
      ctaLabel,
      link,
      pageLink,
      openNewTab,
    } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-circle-box ' + props.className}
      >
        <OriginalCircleBox
          item={{
            name: children.props.children[0],
            description: children.props.children[1],
            ctaLabel: ctaLabel,
            url: pageLink || link || '#',
            blank: openNewTab
          }}
          animationVariant={animationVariant}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

CircleBox.craft = withCraft({
  name: 'CircleBox',
  defaultProps: defaultProps,
  settings: CircleBoxSettings,
});
